module.exports = __webpack_public_path__ + "static/media/NAM.b2c76511.png";